<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Angaben zu den Betriebskosten
            </h1>
            <h2>
                Wie möchten Sie die ortsübliche Miete berechnen?
            </h2>
        </div>
        <p class="validationError" role="alert" v-if="validationError">
            <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
        </p>
        <div class="mb-5">
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" ref="itemGroupTop" :aria-active-descendant="selectedItem" v-model="selectedItemTop" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in itemsA">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelectedA(item.id)" :title="$t('betriebskosten.a' + item.id)">
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title v-html="$t('betriebskosten.a' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>

        <!-- IF ACTIVATED -->
        <div class="mb-5">
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group" :disabled="selectedItemTop == '0' || selectedItemTop == null">
                    <v-list-item-group multiple role="list" tabindex="0" ref="betriebskostenList" :aria-active-descendant="selectedItem" v-model="selectedItemBottom" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in itemsB">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                :disabled="selectedItemTop == '0'"
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="checkbox" tabindex="-1" :checked="isSelectedB(item.id)" :title="$t('betriebskosten.' + item.id)">
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(!isSelectedB(item.id) ? 'lineThrough' : '')" v-html="$t('betriebskosten.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>

        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Miete berechnen"><span class="black--text subtitle-1">Miete berechnen</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Betriebskosten (Nebenkosten)</h3><br/>
                            <h3>Ortsübliche Miete ohne Betriebskosten (Nettomiete)</h3><br/>
                            <p>
                                Im Regelfall ist im Mietvertrag eine Nettomiete vereinbart, das heißt alle anfallenden
                                Betriebskosten gemäß Paragraf zwei der Betriebskostenverordnung beziehungsweise
                                Anlage drei zu Paragraf 27 der II. Berechnungsverordnung werden entweder als
                                Vorauszahlung (mit jährlicher Abrechnung) oder als Pauschale (ohne jährliche
                                Abrechnung) bezahlt.
                            </p>
                            <h2>Mit allen Betriebskosten (Bruttomiete) beziehungsweise teilweise mit Betriebskosten (Teilinklusivmiete)</h2><br/>
                            <p>Falls die Betriebskosten nicht alle gesondert an die*den Vermieter*in bezahlt werden,
                            markieren Sie bitte alle Betriebskosten, die neben der (Grund-)Miete extra vereinbart sind (zum Beispiel als
                            Pauschale). Markieren Sie bitte auch Betriebskosten, die neben der Miete direkt an das Versorgungsunternehmen
                            bezahlt werden oder gar nicht erst entstehen. </p>

                            <p><b>Hinweis:</b> Zum Stichmonat Januar 2024 war eine Umlage der Kosten für 
                                <b>Kabelfernsehen beziehungsweise der Gemeinschaftsantenne</b> als Betriebskosten zulässig. Seit 1. Juli 2024 
                                ist eine Umlage nicht mehr zulässig.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { createNamespacedHelpers } from 'vuex';

    const { mapActions } = createNamespacedHelpers('berechnung')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        computed: { ...mapGetters(['hasPermission']) },
        methods: { ...mapActions(['SELECT_BETRIEBSKOSTEN']) }
    })
    export default class Betriebskosten extends Vue {

        data() {
            return {
                index: 19,
                selectedItemTop: this.$store.state.berechnung.selectedBetriebskostenA,
                selectedItemBottom: this.$store.state.berechnung.selectedBetriebskostenB,
                itemsA: [
                    { id: 0
                    },
                    { divider: true},
                    { id: 1},
                ],
                itemsB: [
                    { id: 0
                    },
                    { divider: true},
                    { id: 1},
                    { divider: true},
                    { id: 2},
                    { divider: true},
                    { id: 3},
                    { divider: true},
                    { id: 4},
                    { divider: true},
                    { id: 5},
                    { divider: true},
                    { id: 6},
                    { divider: true},
                    { id: 7},
                    { divider: true},
                    { id: 8},
                    { divider: true},
                    { id: 9},
                    { divider: true},
                    { id: 10},
                    { divider: true},
                    { id: 11},
                    { divider: true},
                    { id: 12},
                    { divider: true},
                    { id: 13},
                    { divider: true},
                    { id: 14},
                    { divider: true},
                    { id: 15},
                    { divider: true},
                    { id: 16},
                    { divider: true},
                    { id: 17},
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        _isBottomActive() {
            return this.$data.selectedItemTop == "0";
        }

        isSelectedA(index) {
            return index == this.$data.selectedItemTop;
        }

        isSelectedB(index) {
            if(this.selectedItemBottom != null) {
                return this.selectedItemBottom.includes(index);
            }
        }

        selectAndNext(id) {
            this.$data.selectedItemTop = id;
            this.next();
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            window.scrollTo(0,0);
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            this.$root.$on('unfocusList', target => {
                if(target.parentElement === vm.$refs.betriebskostenList.$el){
                    vm.$refs.itemGroupTop.$el.focus()
                }
            })
            this.$refs.itemGroupTop.$el.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            this.$refs.betriebskostenList.$el.addEventListener('focus', event => {
                if(event.target.parentElement.className.includes('disabled') || event.target.parentElement.parentElement.className.includes('disabled')) return
                event.target.firstChild.focus()
            })

            //item group handling: (un)select on spacebar and (un)set appropriate aria attribute and class
            this.$refs.itemGroupTop.$el.addEventListener('keydown', event => this.itemSelection(event, vm))
            this.$refs.betriebskostenList.$el.addEventListener('keydown', event => this.multiItemSelection(event, vm))
        }

        multiItemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItemBottom.includes(id)){
                setTimeout(function(){
                    let selection = vm.selectedItemBottom.slice()
                    selection.splice(selection.indexOf(id), 1)
                    vm.selectedItemBottom = selection
                }, 100)
            }else{
                setTimeout(function(){
                    let selection = vm.selectedItemBottom.slice()
                    selection.push(id)
                    vm.selectedItemBottom = selection
                }, 100)
            }
            event.preventDefault()
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItemTop === id){
                setTimeout(function(){
                    vm.selectedItemTop = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItemTop = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItemTop == undefined || this.selectedItemTop == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedItemTop)
            // Wirklich immer? Der aktuelle Miespiegel speichert den unteren Teil immer, egal was oben ausgewählt wurde.
            this.SELECT_BETRIEBSKOSTEN({selectedBetriebskostenA: this.selectedItemTop, selectedBetriebskostenB: this.selectedItemBottom})
            this.$router.push('berechnungsergebnisse');
        }

        back() {
            this.$router.push('abweichungen')
        }
    }
</script>
